<template>
  <div>
    <div
      v-for="(block, index) of renderBlocks"
      :key="index"
    >
      <LazyHydrationWrapper
        :when-visible="{ rootMargin: '50px' }"
      >
        <component
          v-bind="block.props"
          :is="block.componentName"
          :placeholders="block.placeholders"
          :external-data="externalData"
          :breadcrumbs="breadcrumbs"
        >
          <template
            v-for="(slotName ) in block.slots"
            #[slotName]
            :key="slotName"
          >
            <component
              :is="'LayoutPlaceholder'"
              :level="currentLevel + 1"
              :blocks="block.placeholders[slotName]"
              :external-data="externalData"
            ></component>
          </template>
        </component>
      </LazyHydrationWrapper>
    </div>
  </div>
</template>

<script setup lang="ts">
import { extractBlocks } from '#sitis/cms/helpers';
import { ref, computed } from '#imports';
import type { IContentBlockCms } from '#sitis/internal/controllers/cms/models/Content';
import { LazyHydrationWrapper } from 'vue3-lazy-hydration';
import type { IBreadcrumbs } from '#sitis/stores/modules/catalog-store';

const props = withDefaults(defineProps<{
	level?: number;
	blocks?: IContentBlockCms[];
	externalData?: any;
	breadcrumbs?: IBreadcrumbs[];
}>(), {
  blocks: () => [],
  externalData: () => ({}),
  level: 0
});

const renderBlocks = computed(() => {
  const blocks: any = [];

  [...props.blocks].map((block: any) => {
    if (block.extras?.placeholder && block.placeholders && block.placeholders?.[block.extras?.placeholder]) {
      const placeholder = block.placeholders?.[block?.extras?.placeholder];

      if (Array.isArray(placeholder)) {
        blocks.push(...placeholder);
        return;
      }

      blocks.push(placeholder);
    }

    blocks.push(block);
  });

  return extractBlocks(blocks);
});

const currentLevel = ref(props.level);
</script>
